{
  "_license": "Copyright (c) 2025 Goffy. This file belongs to Goffy. All Rights Reserved.",
  "course": {
    "error": "Kan ikke indlæse golfklubbar",
    "insecure": "Using a default location (needs HTTPS for precise location).",
    "label": "Brug närmaste golfklubb",
    "enableLocationHint": "(Aktivér placering for detta)",
    "loading": "Hitta golfklubbar",
    "none": "Ingen golfklubbar i nærheden",
    "permissionDenied": "Platsbehörigheter nekade",
    "helpLabel": "Hjælp for placering",
    "helpTitle": "Aktivér placering for närmaste golfklubb",
    "helpDescription": "Tillåt placeringåtkomst i webbläsaren eller enhedens indstillinger for at automatisk hitta klubbar i nærheden.",
    "refresh": "Opdater",
    "select": "Vælg golfklubb"
  },
  "appError": {
    "title": "Något gick fel",
    "message": "Indlæs om sidan. Om problemet kvarstår, kontakta support.",
    "retry": "Prøv igen"
  },
  "edit": {
    "autosave": "Ändra texten, gemme filen så opdateres din app automatisk.",
    "help": "Tryk her, hvis din app ikke opdateres automatisk efter at du har gjort ændringer",
    "openCode": "Öppna koden for denne skärmen:"
  },
  "menu": {
    "profile": "Profil",
    "about": "Om",
    "aboutTitle": "Tjänststatus",
    "aboutLoading": "Henter status...",
    "aboutEmpty": "Ingen statusdata tillgänglig.",
    "aboutError": "Fel:",
    "aboutLoadError": "Kunne ikke hente status.",
    "aboutUnknownService": "Okänd tjänst",
    "aboutUnknownImage": "Okänd billede",
    "home": "Hjem",
    "friends": "Venner",
    "hole": "Hul",
    "selectGames": "Vælg spil",
    "tour": "Tour",
    "configCourse": "Konfigurera bana",
    "roundResults": "Runde",
    "scorecard": "Scorekort",
    "more": "Meny",
    "back": "<- Tilbage",
    "logout": "Log ud",
    "close": "Luk",
    "anonymous": "Gäst",
    "reportBug": "Rapportera bugg",
    "reportBugTitle": "Rapportera bugg",
    "reportBugHint": "Beskriv vad som skete. Inkludera forventet og faktisk resultater.",
    "reportBugDescriptionPlaceholder": "Vad skete? Vad förväntade du dig?",
    "reportBugAddImage": "Tilføj billede",
    "reportBugRemoveImage": "Fjern billede",
    "reportBugPasteHint": "Tip: indsæt en billede fra udklipsholder når denne dialogen er öppen.",
    "reportBugSend": "Skicka rapport",
    "reportBugSending": "Skickar...",
    "reportBugSent": "Buggrapport sendt til Slack #bugs.",
    "reportBugSendFailed": "Kunne ikke sende buggrapport",
    "reportBugInvalidImage": "Endast billedefiler stöds.",
    "reportBugImageTooLarge": "Bilden er for stor (max 8 MB).",
    "reportBugMissingContent": "Tilføj en beskrivning eller billede innan du sender.",
    "reportBugFileUnsupported": "Filuppladdning stöds bara på webben."
  },
  "profile": {
    "title": "Profil",
    "loading": "Henter profil...",
    "loadFailed": "Kunne ikke hente profil.",
    "playerProvisioning": "Opretter din spillerprofil...",
    "displayNameLabel": "Vist navn",
    "displayNamePlaceholder": "Dit kaldenavn",
    "fullNameLabel": "Fulde navn",
    "fullNamePlaceholder": "Dit fulde navn",
    "nameLabel": "Namn",
    "namePlaceholder": "Ange ditt namn",
    "emailLabel": "E-mail",
    "emailPlaceholder": "navn@example.com",
    "genderLabel": "Køn",
    "genderPlaceholder": "mand, kvinde eller andet",
    "genderMale": "Mand",
    "genderFemale": "Kvinde",
    "genderNeutral": "Neutral",
    "handicapLabel": "Handicap",
    "handicapPlaceholder": "fx 12,4",
    "handicapDateLabel": "Handicapdato",
    "handicapDatePlaceholder": "ÅÅÅÅ-MM-DD",
    "imageLabel": "Profilbillede",
    "uploadImage": "Indlæs upp billede",
    "selectAvatar": "Vælg avatar",
    "removeAvatar": "Fjern avatar",
    "avatarPickerTitle": "Vælg en avatar",
    "avatarMore": "Fler",
    "avatarLoading": "Indlæser avatarer...",
    "close": "Luk",
    "save": "Gem",
    "saving": "Gemr...",
    "saveSuccess": "Profil gemmed.",
    "saveFailed": "Kunne ikke gemme profil.",
    "handicapRequired": "Angiv handicap når handicapdato er sat.",
    "handicapDateRequired": "Angiv handicapdato når handicap er sat.",
    "invalidHandicap": "Angiv en gyldig handicapværdi.",
    "invalidHandicapDate": "Angiv en gyldig handicapdato (ÅÅÅÅ-MM-DD).",
    "homeClubsLabel": "Hjemmeklubber",
    "homeClubsEmpty": "Ingen hjemmeklub valgt.",
    "homeClubsAdd": "Tilføj hjemmeklub",
    "homeClubsPrimary": "Primær",
    "homeClubsSetPrimary": "Sæt som primær",
    "homeClubsRemove": "Fjern",
    "homeClubsPickerTitle": "Vælg hjemmeklub",
    "homeClubsSearchPlaceholder": "Søg klub...",
    "homeClubsLoading": "Indlæser klubber...",
    "homeClubsNoResults": "Ingen klubber fundet.",
    "homeClubsUnknownLocation": "Ukendt sted",
    "homeClubsRefresh": "Opdater",
    "homeClubsLoadFailed": "Kunne ikke indlæse klubber.",
    "uploading": "Indlæser upp billede...",
    "uploadSuccess": "Bild uppindlæsed.",
    "uploadFailed": "Kunne ikke indlæse upp billede.",
    "permissionDenied": "Behov av fotobibliotekstillstånd."
  },
  "teamDraw": {
    "title": "Lottade lag"
  },
  "serviceStatus": {
    "buttonLabel": "Tjänststatus",
    "alert": "!",
    "title": "Tjänster saknas",
    "allOk": "Alla tjänster er igång.",
    "warningsFound": "Varningenr eller fel fundet i loggar.",
    "unknownTimestamp": "Okänd tidpunkt",
    "unknownService": "Okänd tjänst",
    "unknownBody": "Ingen loggtext",
    "continueMissing": "Fortsæt (mangler: {missing})",
    "close": "Luk",
    "checkedAt": "Kontrollerad: {time}",
    "bffName": "backend-for-frontend-service"
  },
  "debug": {
    "button": "Debug",
    "buttonLabel": "Debug-information",
    "title": "Debug-info",
    "userLabel": "Brugare",
    "userIdLabel": "Brugar-ID",
    "playerIdLabel": "Spilar-ID",
    "roundLabel": "Runde-ID",
    "roundNameLabel": "Rundenamn",
    "tourLabel": "Tour-ID",
    "tourNameLabel": "Tournavn",
    "holeViewTraceLabel": "TraceId hulvy",
    "holeScoreTraceLabel": "TraceId hulscore",
    "traceNone": "Ingen",
    "copyIdsLabel": "Kopiera debug-ID",
    "copyIdLabel": "Kopiera {label}",
    "loading": "Henter namn...",
    "unknown": "Okänt",
    "close": "Luk",
    "disable": "Luk av debug",
    "resetCoachMarks": "Återställ coach marks",
    "resetCoachMarksRunning": "Återställer coach marks...",
    "resetCoachMarksSuccess": "Coach marks återställda for användaren.",
    "resetCoachMarksError": "Kunne ikke återställa coach marks.",
    "coachMarksTitle": "Coach marks",
    "coachMarksEmpty": "Ingen coach marks indlæsedes.",
    "coachMarkLabel": "Coach mark: {key}",
    "deeplinkTitle": "Deep link-debugg",
    "deeplinkPlatform": "Plattform",
    "deeplinkLatest": "Senaste URL",
    "deeplinkEmpty": "Ingen deep link mottagen ännu."
  },
  "welcome": {
    "title": "Velkommen",
    "body": "Vælg hvordan du vil starte: opret en enkelt runde, start en ny tour eller åbn dine eksisterende tours og ikke-afsluttede runder.",
    "startSingleRound": "Start enkelt runde",
    "startTour": "Start tour",
    "myTours": "Mine tours og runder",
    "myToursOpenSummary": "Åbne tours: {tours} · Enkelt runder: {singleRounds}",
    "myToursNav": "Mine runder"
  },
  "friends": {
    "title": "Venner",
    "loading": "Indlæser venner...",
    "empty": "Ingen venner tilføjet endnu.",
    "myFriends": "Mine venner",
    "linked": "Tilknyttet bruger",
    "guest": "Gæsteprofil",
    "addLinked": "Tilføj tilknyttet spiller",
    "addGuest": "Tilføj gæstespiller",
    "searchPlaceholder": "Søg spillere",
    "guestPlaceholder": "Gæstenavn",
    "createGuestAndAdd": "Opret gæst og tilføj",
    "add": "Tilføj",
    "remove": "Fjern",
    "editNickname": "Rediger kaldenavn",
    "cancel": "Annuller",
    "nicknamePlaceholder": "Kaldenavn (valgfrit)",
    "saveNickname": "Gem kaldenavn",
    "loadPlayersError": "Kunne ikke indlæse platformspillere.",
    "guestCreateFailed": "Kunne ikke oprette gæstespiller.",
    "actionFailed": "Kunne ikke opdatere venner.",
    "findPlayersPlaceholder": "Find spillere...",
    "allFriends": "Alle venner",
    "recent": "Seneste",
    "eliteStatus": "Elite status",
    "myFriendsCount": "Mine venner {count}",
    "noMatches": "Ingen venner matcher din søgning."
  },
  "coachMarks": {
    "tournamentsCreateTitle": "Opret din første turnering",
    "tournamentsCreateBody": "Brug knappen for at oprette en ny turnering og gå videre til rundeopsætning.",
    "profileImageActionsTitle": "Vælg profilbillede",
    "profileImageActionsBody": "Indlæs upp en billede eller välj en avatar som vises tillsammans med ditt namn.",
    "holeScoreTitle": "Tips til score-rækken",
    "holeScoreBody": "Tryk på Score for at åbne scoreindtastning og registrere hazard- eller mystery-resultater. Du kan også swipe til venstre eller højre på en spillerrække for at justere slag.",
    "gotIt": "Jag förstår"
  },
  "courseConfig": {
    "title": "Konfigurera bana",
    "clubLabel": "Klubb",
    "clubPlaceholder": "Klubbnamn",
    "courseLabel": "Bana",
    "coursePlaceholder": "Bannamn",
    "holeHeader": "Hul",
    "parHeader": "Par",
    "strokeIndexHeader": "Index",
    "teesTitle": "Tee-opsætning",
    "addTeeButton": "Tilføj tee",
    "teeLabel": "Tee {index}",
    "removeTeeButton": "Fjern",
    "teeNameLabel": "Tee-navn",
    "teeNamePlaceholder": "Gul",
    "teeGenderLabel": "Køn",
    "genderMale": "Mand",
    "genderFemale": "Kvinde",
    "genderUnisex": "Unisex",
    "teeParLabel": "Tee par",
    "courseRatingLabel": "Course rating",
    "slopeRatingLabel": "Slope rating",
    "cancelButton": "Annuller",
    "saveButton": "Gem bana",
    "saving": "Gemr bana...",
    "waitingConnection": "Venter på websocket-forbindelse...",
    "saveSuccess": "Bana gemmed {id}",
    "saveRejected": "Det lykkedes ikke at gemme banen.",
    "clubRequired": "Klubbnamn skal anges.",
    "courseRequired": "Bannamn skal anges.",
    "invalidPar": "Alla hul skal ha et parvärde.",
    "invalidStrokeIndex": "Alla hul skal ha et index.",
    "teesRequired": "Tilføj mindst én tee.",
    "teeNameRequired": "Alle tees skal have et navn.",
    "teeGenderRequired": "Alle tees skal have et køn.",
    "invalidCourseRating": "Alle tees skal have en gyldig course rating.",
    "invalidSlopeRating": "Alle tees skal have en gyldig slope rating.",
    "invalidTeePar": "Alle tees skal have en gyldig parværdi."
  },
  "tournaments": {
    "title": "Turneringer",
    "loading": "Indlæser turneringer...",
    "menuLabel": "Turneringval",
    "showFinished": "Vis afsluttede",
    "hideFinished": "Skjul afsluttede",
    "showFinishedSingleRounds": "Vis afsluttede enkelt runder",
    "hideFinishedSingleRounds": "Skjul afsluttede enkelt runder",
    "statusContinue": "Fortsätt",
    "statusPause": "Pausa",
    "statusArchive": "Arkivera",
    "statusSleep": "Viloläge",
    "statusCancel": "Avbryt",
    "statusUpdateSent": "Opdaterer status til {status}...",
    "statusUpdateAck": "Turneringstatus opdatered.",
    "statusUpdateQueued": "Venter på websocket...",
    "archiveTitle": "Turnering opdatered",
    "archiveMessage": "Turneringstatus opdateredes.",
    "loadError": "Det lykkedes ikke at hente turneringer.",
    "empty": "Ingen turnering fundet. Opret en ny.",
    "noTurnerings": "Ingen turnering fundet.",
    "defaultName": "Ny turnering",
    "namePlaceholder": "Turnering namn",
    "creating": "Opretr turnering...",
    "createCta": "Ny turnering",
    "singleRoundCta": "Enkelt runde",
    "createdNotice": "Ny turnering har oprettet. Vælg turnering fra listan.",
    "createdWithId": "Turnering opretted: {id}",
    "createFailed": "Kunne ikke oprette turnering just nu. Prøv igen.",
    "membersTitle": "Turneringmedlemmar",
    "membersLoading": "Indlæser spillere...",
    "membersCount": "Valda: {selected}/{max}",
    "membersLoadError": "Det lykkedes ikke at indlæse platformsspillere.",
    "playerProvisioning": "Opretr din spillerprofil...",
    "playerProvisioningRetry": "Spilarprofilen er försenad. Prøv igen.",
    "playerProvisioningTimeout": "Tiden løb ud for at oprette spillerprofilen. Prøv igen.",
    "playerProvisioningActionRetry": "Prøv igen",
    "playerProvisioningBlocked": "Vänta tills din spillerprofil er klar innan du opretter en turnering.",
    "creatorMemberLocked": "Din spillere er alltid med i turneringen og kan ikke fjernes.",
    "creatorMemberRequired": "Din spillerprofil skal vara med innan du kan oprette en turnering.",
    "shareCta": "Dela",
    "shareTitle": "Dela {name}",
    "shareSubtitle": "Alla med länken kan se live-resultater for turneringen.",
    "shareAction": "Dela länk",
    "shareClose": "Luk",
    "shareLoadError": "Kunne ikke oprette en inbjudningslänk for denne turnering.",
    "shareSendError": "Det lykkedes ikke at dele invitationlinket på denne enheden.",
    "shareCopied": "Inbjudningslänk kopierad.",
    "openButton": "Öppna",
    "newRoundCta": "Tilføj runde",
    "roundsTitle": "Runder",
    "unfinishedRoundsTitle": "Ikke-afsluttede runder",
    "hiddenToursSingleRoundsTitle": "Enkelt runder",
    "roundsLoading": "Indlæser runder...",
    "roundsEmpty": "Ingen runder fundet.",
    "roundsLoadError": "Det lykkedes ikke at indlæse runder.",
    "myToursAndRoundsSummary": "Tours: {tours} · Ikke-afsluttede runder: {rounds}",
    "roundFallbackName": "Runde",
    "roundOpen": "Öppna",
    "roundStart": "Starta",
    "roundUpdate": "Opdater",
    "roundSettings": "Rundeindstillinger",
    "roundResults": "Resultater",
    "roundStatus": "Status: {status}",
    "roundStatusWithDate": "Status: {status} · {date}",
    "editCta": "Redigera",
    "gamesTitle": "Spil",
    "gamesCount": "{count} spil",
    "gamesLoading": "Indlæser spil...",
    "gamesEmpty": "Ingen spil valda.",
    "gamesLoadError": "Det lykkedes ikke at indlæse spil.",
    "groupsLoading": "Indlæser grupper...",
    "groupsLoadError": "Det lykkedes ikke at indlæse grupper.",
    "gameFallbackName": "Spil",
    "gameTypeUnknown": "Övrigt",
    "gameTypeLabel": "Typ:",
    "gameTypeMissing": "Typ: Okänd",
    "gameWeightLabel": "Vikt",
    "gameDetailsTitle": "Spildetaljer",
    "gameDetailsEmpty": "Ingen beskrivning tillgänglig.",
    "gameCalculationLabel": "Beräkning:",
    "addGame": "Tilføj spil",
    "addGameTitle": "Tilføj spil",
    "addGameEmpty": "Alla spil er redan tillagda."
  },
  "tourEdit": {
    "playersTitle": "Spillere",
    "addPlayer": "Tilføj spillere",
    "removePlayer": "Fjern",
    "playerCreateTemporary": "Opret tillfällig",
    "playerTemporarySelected": "Tillfällig vald",
    "playerSearchPlaceholder": "Sök spillere",
    "playerCurrentUserFallback": "Du",
    "playerConfirmSelectOrTemporary": "Vælg en befintlig spillere eller markera som tillfällig innan du bekräftar.",
    "playerConfirmEmpty": "Ange et spillernamn innan du bekräftar.",
    "playerAlreadyInTurnering": "Spilleren findes redan i turneringen.",
    "playerConfirmA11y": "Bekräfta spillerrad",
    "playerCancelA11y": "Avbryt spillerrad",
    "playerTemporaryToggleA11y": "Växla tillfällig spillere",
    "playerInviteTooltip": "Inviter",
    "playerInviteA11y": "Inviter {name}",
    "playerInviteTitle": "Inviter {name}",
    "playerInviteSubtitle": "Del dette link med {name} for at deltage i touren.",
    "playerInviteLoadError": "Kunne ikke oprette et invitationslink for denne spiller.",
    "playerInviteShareError": "Det lykkedes ikke at dele invitationslinket.",
    "playerInviteCopied": "Invitationslink kopieret.",
    "title": "Turnering redigering",
    "breadcrumbTitle": "Tävling - redigering",
    "subtitle": "Webbversion",
    "backToTurnerings": "Till turnerings",
    "tourIdLabel": "Tour-ID",
    "tourIdMissing": "Tour-ID mangler.",
    "webOnlyNote": "Denne sidan findes bara på webben.",
    "nameLabel": "Turnering-namn",
    "namePlaceholder": "Ange turneringnamn",
    "saveCta": "Gem",
    "saving": "Gemr...",
    "saveSent": "Gemr turnering...",
    "saveQueued": "Venter på websocket...",
    "saveAck": "Turnering opdatered.",
    "saveFailed": "Det lykkedes ikke at opdatere turnering.",
    "saveAll": "Gem alla",
    "saveAllSent": "Gemr alla indstillinger...",
    "loading": "Indlæser turnering...",
    "loadError": "Det lykkedes ikke at indlæse turnering.",
    "nameRequired": "Ange et turneringnamn.",
    "addRound": "Tilføj runde",
    "roundNameLabel": "Rundenamn",
    "roundDateLabel": "Spildatum",
    "roundDateUnset": "Vælg datum",
    "roundDatePicker": "Öppna kalender",
    "roundDatePickerTitle": "Vælg datum",
    "roundDatePickerToday": "Idag",
    "roundCreate": "Opret runde",
    "roundCreateSaving": "Opretr...",
    "roundCreateFailed": "Det lykkedes ikke at oprette runden.",
    "roundCreateNoPlayers": "Ingen spillere fundet for tävlingen.",
    "roundCreatePlayerLoading": "Indlæser spillere...",
    "addImage": "Tilføj billede",
    "uploadingImage": "Indlæser upp billede...",
    "imageUploadFailed": "Det lykkedes ikke at indlæse billedet.",
    "imageUploadSuccess": "Tävlingsbilledeen opdatered.",
    "roundPlayersTitle": "Rundspillere",
    "roundPlayersLoading": "Indlæser rundespillere...",
    "roundPlayersEmpty": "Ingen spillere i runden ännu.",
    "memberRemoving": "Fjerner spillere fra turneringen...",
    "memberRemoveSent": "Fjerner spillere fra turneringen...",
    "memberRemoved": "Spilleren blev fjernet fra turneringen.",
    "memberRemoveRejected": "Det lykkedes ikke at fjerne spilleren fra turneringen.",
    "memberRemoveTimeout": "Tidsgränsen for borttagning av turneringspillere överskreds.",
    "roundMemberRemoving": "Fjerner spillere fra runden...",
    "roundMemberRemoveSent": "Fjerner spillere fra runden...",
    "roundMemberRemoved": "Spilleren blev fjernet fra runden.",
    "roundMemberRemoveRejected": "Det lykkedes ikke at fjerne spilleren fra runden.",
    "roundMemberRemoveTimeout": "Tidsgränsen for borttagning av rundespillere överskreds.",
    "removeRound": "Fjern runde",
    "roundRemoving": "Fjerner runde...",
    "roundRemoveSent": "Fjerner runde...",
    "roundRemoved": "Runden blev fjernet.",
    "roundRemoveRejected": "Det lykkedes ikke at fjerne runden.",
    "roundRemoveTimeout": "Tidsgränsen for borttagning av runde överskreds.",
    "roundRemoveBlockedScores": "Runden har registrerade scorer",
    "roundRemoveA11y": "Fjern runde",
    "roundPlayerRemoveBlockedScores": "Har registrerade scorer",
    "roundPlayerRemoveBlockedLastPlayer": "Sista spilleren i runden",
    "roundPlayerRemoveA11y": "Fjern spillere fra runden",
    "roundPlayerRemoveDisabledA11y": "Spilleren kan ikke fjernes fra runden",
    "roundAddPlayer": "Tilføj spillere",
    "roundAddPlayerPlaceholder": "Vælg turneringmedlem",
    "roundAddPlayerNoCandidates": "Ingen tilgængelige turneringsmedlemmer at tilføje.",
    "roundAddPlayerStatusBlocked": "Rundstatus tillader ikke at spillere tilføjes.",
    "playerDropHintAdd": "Træk hertil for at tilføje til spillere",
    "playerDropHintAddActive": "Slip for at tilføje til spillere",
    "playerDropHintRemove": "Træk rundespillere hit for at fjerne",
    "playerDropHintRemoveActive": "Slip for at fjerne fra runden",
    "cancelRound": "Avbryt",
    "done": "Klar",
    "playerSearchNoResults": "Ingen spillere fundet."
  },
  "auth": {
    "loginTitle": "Log ind",
    "loginCardTitle": "Välkommen tillbaka",
    "loginCta": "Login",
    "loggingIn": "Loggar in...",
    "loginSubtitle": "Inloggning",
    "loginHint": "Du sendes til Keycloak for at logge ind.",
    "debugLabel": "Inloggad",
    "debugNone": "Ingen",
    "callbackLoading": "Slutför inloggning...",
    "callbackReady": "Venter på svar fra Keycloak"
  },
  "login": {
    "userNotFound": "Din bruger findes ikke længere. Log ind igen."
  },
  "start": {
    "title": "Velkommen til Goffy",
    "subtitle": "Indtast en invitationskode, hvis du har en, eller fortsæt med en ny eller eksisterende konto.",
    "roundCodeLabel": "Invitationskode",
    "roundCodePlaceholder": "Indtast invitationskode",
    "roundCodeRequired": "Indtast en invitationskode for at fortsætte.",
    "roundCodeInvalid": "Den invitationskode blev ikke fundet.",
    "roundCodeLookupFailed": "Invitationskoden kunne ikke åbnes. Prøv igen.",
    "joinWithCodeCta": "Deltag med kode",
    "signUpCta": "Opret konto",
    "logInCta": "Log ind"
  },
  "register": {
    "title": "Opret konto",
    "cardTitle": "Opret ditt konto",
    "usernameLabel": "Brugernavn",
    "usernamePlaceholder": "ditnavn",
    "displayNameLabel": "Vist navn",
    "displayNamePlaceholder": "Dit kaldenavn",
    "fullNameLabel": "Fulde navn",
    "fullNamePlaceholder": "Dit fulde navn",
    "emailLabel": "E-post",
    "emailPlaceholder": "namn@example.com",
    "passwordLabel": "Lösenord",
    "passwordPlaceholder": "Minst 6 tecken",
    "creating": "Opretr...",
    "createCta": "Opret konto",
    "connectionLabel": "BFF-forbindelse: {status}",
    "connectionUp": "aktiv",
    "connectionDown": "frånkopplad",
    "backToLogin": "Tilbage til startsiden",
    "statusQueued": "Skickar förfrågan...",
    "statusSuccess": "Konto oprettet! Log ind med din e-post og adgangskode.",
    "validationMissing": "Ange e-post, vist navn, fulde navn og lösenord.",
    "validationAcceptTerms": "Du skal acceptere vilkårene for at oprette en konto.",
    "validationPasswordTooShort": "Lösenordet måste vara minst {{min}} tecken.",
    "connectionMissing": "Ingen forbindelse til BFF. Prøv igen.",
    "createTimeout": "Opret-forespørgslen tog for lang tid. Prøv igen.",
    "userExists": "En användare med den e-posten findes redan.",
    "createFailed": "Kunne ikke oprette användare.",
    "acceptTermsLabel": "Jeg accepterer tjenestens vilkår.",
    "openTermsCta": "Læs vilkår",
    "closeTermsCta": "Luk",
    "termsTitle": "Tjenestevilkår",
    "termsSummary": "Kort version: vis respekt, brug Goffy til golfrelateret aktivitet, og beskyt din konto.",
    "termsRuleAccount": "Du er ansvarlig for aktivitet på din konto.",
    "termsRulePrivacy": "Vi gemmer kontodata, der er nødvendige for at drive tjenesten.",
    "termsRuleFairUse": "Du må ikke misbruge, angribe eller forstyrre tjenesten.",
    "termsRuleNoWarranty": "Tjenesten leveres som den er, uden garantier.",
    "termsUpdated": "Vilkårene kan blive opdateret over tid."
  },
  "home": {
    "addPlayers": "+ Tilføj spillere",
    "maxPlayers": "Max 8 spillere",
    "namePlaceholder": "Ange namn",
    "primaryCta": "Vælg spil",
    "saveError": "Det lykkedes ikke at gemme spillere.",
    "saving": "Gemnde...",
    "scpPlaceholder": "SHCP",
    "scpRequired": "Ange SHCP for alla spillere.",
    "title": "Tilføj spillere",
    "playerLabel": "Spillere {index}",
    "validationRequired": "Ange minst en spillere."
  },
  "selectGames": {
    "title": "Vælg spil",
    "waiting": "Venter på turnering-ID...",
    "tourIdLabel": "Aktuelt tour-ID",
    "tourLabel": "Tour",
    "roundLabel": "Runde",
    "playersLabel": "Spillere: {count}",
    "gamesLabel": "Spiltyper: {count}",
    "missing": "saknas",
    "hint": "Hull skärmen öppen tills turneringen er klar.",
    "gameListTitle": "Vælg et spil",
    "recommendedBadge": "Anbefalet",
    "gameInfo": "Info",
    "gameDescription": "Beskrivning",
    "infoIcon": "i",
    "infoVideoTitle": "Mystery-spil info",
    "infoVideoTitleByGame": "{name} spilinfo",
    "gameNameFallback": "Spil",
    "infoDescriptionTitle": "Beskrivning",
    "infoDescriptionEmpty": "Ingen beskrivning tillgänglig.",
    "infoDescriptionExtra": "Dette spil scores hul for hul og påvirker rundens samlede resultat ud fra sin vægt.",
    "infoGameTypeTitle": "Spiltype",
    "infoGameTypeDefault": "Pointbaseret sidegame",
    "infoWeightTitle": "Vægtindstilling",
    "infoWeightValue": "Aktuel vægt: {weight}%",
    "infoWeightHelp": "Vægten styrer hvor meget spillet påvirker totalpoint. 100% giver fuld effekt, lavere værdier reducerer effekten.",
    "closeVideo": "Luk",
    "gameLoadError": "Kunne ikke indlæse spil",
    "gameStartError": "Kunne ikke starte spil",
    "startGame": "Starta spil",
    "startRound": "Start runde",
    "updateCta": "Gem og fortsæt"
  },
  "roundStartSetup": {
    "title": "Rundeindstillinger",
    "subtitleNamed": "Konfigurera spillere og spil for {name}",
    "subtitleFallback": "Konfigurera spillere og spil for denne runde",
    "loading": "Indlæser rundestart...",
    "loadError": "Kunne ikke indlæse rundestart.",
    "playersTitle": "Rundespillere",
    "playersEmpty": "Ingen spillere kopplade til runden.",
    "playingHandicapLabel": "Spil-hcp",
    "playingHandicapPlaceholder": "Play HCP",
    "groupsTitle": "Grupper og hold",
    "groupsHint": "Træk et spillerkort over et andet kort for at bytte, eller tryk først på et kort og derefter på et andet.",
    "groupsLocked": "Grupper er låst, når runden ikke længere er draft.",
    "groupsEmpty": "Ingen gruppelayout tilgængelig.",
    "groupLabel": "Gruppe {index}",
    "teamLabel": "Hold {index}",
    "groupsUpdateSending": "Gemmer gruppebytte...",
    "groupsUpdateSaved": "Grupper opdateret.",
    "groupsUpdateQueued": "Gruppebytte står i kø, indtil websocket er tilbage.",
    "groupsUpdateRejected": "Kunne ikke opdatere grupper.",
    "groupsUpdateSendFailed": "Kunne ikke sende gruppebytte.",
    "groupsUpdateTimeout": "Timeout ved bekræftelse af gruppebytte.",
    "gamesTitle": "Rundespil",
    "gamesEmpty": "Ingen spil kopplade til runden.",
    "addMoreGamesCta": "Tilføj flere spil",
    "removePlayerCta": "Fjern",
    "removingPlayer": "Fjerner spillere...",
    "removeQueued": "Borttagning av spillere köad.",
    "removeSent": "Spilleren er borttagen.",
    "removeRejected": "Det lykkedes ikke at fjerne spilleren fra runden.",
    "disableGameCta": "Inaktivera",
    "enableGameCta": "Aktivér",
    "gamesUpdateQueued": "Rundeopdatering köad.",
    "gamesUpdateSent": "Rundespil opdaterede.",
    "updateCta": "Opdater",
    "openRoundCta": "Öppna runde",
    "openRoundSending": "Öppnar runde...",
    "openRoundQueued": "Rundens statusopdatering köad.",
    "openRoundConfirmed": "Runden er nu aktiv.",
    "openRoundSendFailed": "Kunne ikke sende rundens statusopdatering.",
    "openRoundTimeout": "Runden blev ikke aktiv i tid. Prøv igen."
  },
  "tourLeaderboard": {
    "title": "Turneringsledertavle",
    "tourName": "Tour: {name}",
    "roundCount": "Runder: {count}",
    "points": "{points} p",
    "player": "Spillere",
    "total": "Turnering",
    "gameFallback": "Spil",
    "roundsTitle": "Runder",
    "roundSectionsTitle": "Runder",
    "roundSectionTitle": "Runde {round}: {name}",
    "roundMembersEmpty": "Ingen medlemmar i denne runde.",
    "roundRowLabel": "Runde",
    "roundFallback": "Runde",
    "roundEmpty": "Ingen point ännu.",
    "empty": "Ingen resultater ännu.",
    "missingTurnering": "Ingen turnering vald.",
    "goTurnerings": "Gå til turnerings",
    "loadError": "Kunne ikke indlæse leaderboard.",
    "wsConnecting": "Forbinder til live leaderboard...",
    "wsWaitingData": "Ansluten. Venter på leaderboard-data...",
    "wsRetrying": "Venter fortfarande på leaderboard-data (prøv {count}).",
    "unknownPlayer": "Okänd spillere",
    "resultsHeader": "Resultater",
    "resultsButton": "Graf",
    "resultsTitle": "Turneringresultater",
    "resultsTableTitle": "Resultatertabell",
    "resultsClose": "Luk",
    "resultsError": "Kunne ikke indlæse resultater.",
    "resultsTableButton": "Tabell",
    "downloadCsv": "Indlæs ner CSV",
    "csvError": "Ingen turneringresultater at downloade.",
    "csvUnsupported": "CSV-nedladdning findes bara på webben.",
    "roundPoints": "Rundepoint",
    "claimHeader": "Claima",
    "claimCta": "Claima",
    "claiming": "Claimar...",
    "claimPending": "Anmodning om claim sendt.",
    "claimSuccess": "Spilleren er nu claimad til din profil.",
    "claimTokenMissing": "Claim lykkedes, men midlertidig adgang kunne ikke etableres. Prøv igen.",
    "claimRejected": "Det lykkedes ikke at claima spilleren.",
    "claimSendError": "Kunne ikke sende claim-begäran.",
    "claimReleaseCta": "Annullér claim",
    "claimReleaseSendError": "Kunne ikke annullere claim.",
    "claimReleased": "Claim er annulleret.",
    "waitingForRoundSetupTitle": "Rundeopsætning I Gang",
    "waitingForRoundSetup": "Venter på at rundeopsætningen bliver færdig. Du sendes automatisk til hul 1.",
    "membersTitle": "Turneringmedlemmar",
    "membersClaimHint": "Claima midlertidige medlemmar här.",
    "membersReadOnlyHint": "Log ind for at claima midlertidige medlemmar.",
    "unassignedPlayersTitle": "Ikke-claimede spillere",
    "unassignedPlayersHint": "Vælg din spiller for at begynde at indtaste score.",
    "unassignedPlayersEmpty": "Ingen ikke-claimede spillere tilbage.",
    "membersEmpty": "Ingen medlemmar i denne turnering.",
    "memberTemporary": "Tillfällig medlem",
    "memberClaimed": "Kopplad medlem"
  },
  "tourInvite": {
    "title": "Invitation",
    "courseLabel": "Bane"
  },
  "scorecard": {
    "title": "Scorekort",
    "player": "Spillere",
    "hole": "Hul",
    "par": "Par",
    "index": "Index",
    "strokes": "Slag",
    "points": "Point",
    "out": "Ut",
    "in": "In",
    "total": "Totalt",
    "totalGross": "Slag",
    "totalStableford": "Point",
    "selectRoundTitle": "Vælg runde",
    "selectRoundLoading": "Indlæser runder...",
    "selectRoundEmpty": "Ingen runder tilgængelige.",
    "selectRound": "Vælg",
    "selectRoundError": "Kunne ikke indlæse runder.",
    "selectRoundFallback": "Runde",
    "missingRound": "Ingen runde vald.",
    "loadError": "Kunne ikke indlæse scorekort."
  },
  "language": {
    "english": "Engelsk",
    "label": "Sprog",
    "swedish": "Svensk",
    "danish": "Dansk"
  },
  "modal": {
    "title": "Modal"
  },
  "notFound": {
    "cta": "Gå til startskärmen!",
    "message": "Denne skärmen findes ikke.",
    "title": "hoppsan!"
  },
  "qr": {
    "fallbackError": "Bruger reservlänk eftersom backend ikke er tillgänglig.",
    "subtitle": "Eller tryck nedan for at åbne den direkt",
    "title": "Scan for at åbne länken"
  },
  "tab": {
    "qr": "QR-länk",
    "players": "Spillere"
  },
  "players": {
    "addedAt": "Tillagt:{date}",
    "empty": "Ingen spillere ännu.",
    "loadError": "Det lykkedes ikke at indlæse spillere.",
    "serviceError": "Players service error",
    "title": "Spillere",
    "roundInitTitle": "Ny runde",
    "wsError": "WebSocket-forbindelseen misslyckades.",
    "tourId": "Tour-ID: {id}",
    "tourNameFallback": "Tour",
    "activeRoundsTitle": "Aktiva runder",
    "activeRoundsRefresh": "Opdater",
    "activeRoundsEmpty": "Ingen aktiva runder fundet.",
    "roundsLoadError": "Det lykkedes ikke at indlæse runder.",
    "roundStatus": "Status: {status}",
    "roundStatusWithDate": "Status: {status} · {date}",
    "roundOpen": "Öppna",
    "roundContinue": "Fortsätt",
    "roundFallbackName": "Bana",
    "finishedRoundsTitle": "Avslutade runder",
    "roundResults": "Resultater",
    "roundMenuLabel": "Rundeåtgärder",
    "roundMenuPause": "Pausa",
    "roundMenuFinish": "Avsluta",
    "roundMenuCancel": "Avbryt",
    "roundNamePlaceholder": "Rundenamn",
    "roundDescriptionTitle": "Rundebeskrivning",
    "roundDescriptionPlaceholder": "Tilføj en beskrivning...",
    "roundDescriptionButton": "Redigera rundebeskrivning",
    "playDateLabel": "Spildatum",
    "playDateQuick": "Snabba datum",
    "playDateToday": "Idag",
    "holesCountLabel": "Antal hul",
    "courseLabel": "Bana",
    "courseSearchPlaceholder": "Søg bane",
    "courseSearchEmpty": "Ingen baner fundet.",
    "addCourse": "Tilføj bane",
    "holesCountOptionLabel": "{count} hul",
    "holesCountOptionValue": "{count} hul",
    "teeLabel": "Tee",
    "teeNone": "Ingen",
    "addTemporary": "Tilføj tillfällig spillere",
    "temporaryNamePlaceholder": "Namn på tillfällig spillere",
    "temporaryCreateAction": "Opret spillere",
    "temporaryNameRequired": "Ange namn for tillfällig spillere.",
    "temporaryCreateFailed": "Det lykkedes ikke at oprette tillfällig spillere.",
    "temporaryCreatePending": "Vänta tills midlertidige spillere er oprettede innan runden startes.",
    "temporaryCreatePendingCount": "Opretr midlertidige spillere: {count}",
    "inviteOthers": "Inviter andre",
    "joinWithCode": "Deltag med kode",
    "showQr": "Vis QR",
    "selectFromMembership": "Vælg spillere fra turneringens medlemslista.",
    "membersUpdateTimeout": "Ingen bekräftelse for opdatering av turneringsmedlemmer.",
    "membersUpdateSendFailed": "Det lykkedes ikke at sende opdatering av turneringsmedlemmer.",
    "roundInitiateSendFailed": "Det lykkedes ikke at starte runden.",
    "roundInitiateTimeout": "Start av runde tog for lång tid.",
    "roundInitiateRejected": "Start av runde nekades.",
    "missingTurnering": "Turnering saknas, kan ikke gemme spillere.",
    "missingTour": "Turnering saknas, kan ikke gemme spillere.",
    "singleRoundHiddenTourName": "Enkelt runde",
    "hiddenTourInitiateFailed": "Det lykkedes ikke at starte enkelt runde lige nu."
  },
  "round": {
    "member": {
      "add": {
        "alreadyMember": "Spilleren ingår redan i denne runde.",
        "playerNotInTurnering": "Spilleren skal vara medlem i turneringen innan den kan tilføjes til i runden.",
        "statusNotAllowed": "Spillere kan bara tilføjes til når rundens status er draft, active eller playing.",
        "roundNotFound": "Runden kunne ikke findes.",
        "invalid": "Anmodning om tillägg av rundespillere er ugyldig."
      },
      "remove": {
        "invalid": "Anmodning om borttagning av rundespillere er ugyldig.",
        "invalidPlayer": "Borttagning av rundespillere kräver en giltig spillere.",
        "roundNotFound": "Runden kunne ikke findes.",
        "notMember": "Spilleren ingår ikke i denne runde.",
        "lastPlayer": "En runde skal ha minst en spillere kvar.",
        "hasScores": "Spilleren kan ikke fjernes fra runden efter at scorer har registreret."
      }
    },
    "remove": {
      "invalid": "Anmodning om borttagning av runde er ugyldig.",
      "roundNotFound": "Runden kunne ikke findes.",
      "hasScores": "Runden kan ikke fjernes efter at scorer har registreret."
    },
    "initiate": {
      "membershipRequired": "Alla rundespillere skal vara medlemmar i turneringen."
    }
  },
  "roundResults": {
    "title": "Rundresultater",
    "backToHole": "<- Runderesultater",
    "missingRound": "Vælg en runde for at se resultater.",
    "goPlayers": "Till spillere",
    "loadError": "Kunne ikke indlæse rundresultater.",
    "empty": "Ingen resultater än.",
    "player": "Namn",
    "total": "Point",
    "gameFallback": "Spil",
    "unknownPlayer": "Spillere",
    "roundFallback": "Runde",
    "status": "Status: {status}"
  },
  "summary": {
    "title": "Rundesammanfattning",
    "missingInfo": "Saknar runde-ID eller användartoken.",
    "loadError": "Kunne ikke indlæse rundedata.",
    "overallTitle": "Total leaderboard",
    "playerHeader": "Spillere",
    "scoreHeader": "Score",
    "gameHeader": "Game",
    "pointsHeader": "Totalpoint",
    "gamesTitle": "Resultater per spil",
    "gamesEmpty": "Ingen spilresultater ännu.",
    "hazardsTitle": "Hazardspil",
    "hazardsEmpty": "Ingen hazard-sketelser registrerade.",
    "hazardTotal": "Totalt {count}",
    "hazardWater": "Vatten {count}",
    "hazardBunker": "Bunker {count}",
    "hazardThreePutt": "3-putt {count}",
    "hazardPenalty": "Straff {count}",
    "pointsValue": "{points} p",
    "strokesValue": "{strokes} slag",
    "mysteryTitle": "Mystery-spil höjdpunkter",
    "mysteryEmpty": "Ingen mystery-val fundet.",
    "mysteryHolePrize": "Hul {hole} - {prize}",
    "mysterySubgame": "Delspil: {subgame}",
    "mysteryWinner": "Vinnare: {winner}",
    "mysteryPrizeFallback": "Mystery-pris",
    "parBetterTitle": "Par eller bättre per spillere",
    "parBetterEmpty": "Ingen par-eller-bättre resultater ännu.",
    "parBetterHoles": "Hul: {holes}",
    "parBetterHolesWithResult": "Hul: {holes}",
    "resultPar": "par",
    "resultBirdie": "birdie",
    "resultEagle": "eagle",
    "resultAlbatross": "albatross",
    "resultUnderPar": "under par",
    "unknownPlayer": "Okänd spillere",
    "unknownGame": "Okänt spil",
    "unknownWinner": "Okänd vinnare",
    "unknownMysteryPrize": "Okänt mystery-pris",
    "reopenRoundButton": "Åbn runden igen",
    "doneButton": "Klar"
  },
  "tour": {
    "member": {
      "claim": {
        "invalid": "Anmodning om at claima turneringspillere er ugyldig.",
        "unauthorized": "Log ind for at claima spilleren.",
        "tourNotFound": "Turneringen kunne ikke findes.",
        "sourceNotFound": "Spilleren kunne ikke findes.",
        "sourceNotMember": "Spilleren ingår ikke i denne turnering.",
        "sourceNotUnclaimed": "Spilleren er redan claimad.",
        "targetMissing": "Opret din spillerprofil innan du claimar denne spilleren.",
        "targetAlreadyInTurnering": "Din spillere er redan med i denne turnering.",
        "targetAlreadyInRound": "Din spillere findes redan i en eller flera runder i denne turnering.",
        "mergeConflict": "Claim kunne ikke slutföras eftersom rundedata krockar med din befintliga spillere."
      },
      "remove": {
        "invalid": "Anmodning om borttagning av turneringspillere er ugyldig.",
        "invalidPlayer": "Borttagning av turneringspillere kräver en giltig spillere.",
        "tourNotFound": "Turneringen kunne ikke findes.",
        "notMember": "Spilleren ingår ikke i denne turnering.",
        "creatorProtected": "Turneringens oprettere kan ikke fjernes.",
        "lastMember": "En turnering skal ha minst en medlem kvar.",
        "roundLastPlayer": "Spilleren kan ikke fjernes eftersom en runde då blir tom.",
        "hasScores": "Spilleren kan ikke fjernes fra turneringen efter at scorer har registreret."
      }
    },
    "initiate": {
      "creatorPlayerRequired": "Opret din spillerprofil innan du opretter en turnering.",
      "invalidPlayers": "En eller flera valda spillere kunne ikke findes.",
      "maxPlayersExceeded": "En turnering kan ha max 8 spillere."
    }
  },
  "mysteryPrize": {
    "title": "Mysterypris",
    "subtitle": "Vælg et hul og et delspil for varje spillere.",
    "loading": "Indlæser mystery-setup...",
    "loadError": "Kunne ikke indlæse mysterypriset.",
    "validationError": "Vælg et hul og et delspil for varje spillere.",
    "noPlayers": "Ingen spillere fundet for runden.",
    "noSubgames": "Ingen delspil tilgængelige.",
    "holeLabel": "Hul",
    "subgameLabel": "Delspil",
    "selectHole": "Vælg hul",
    "selectSubgame": "Vælg delspil",
    "save": "Gem mysterypris",
    "saving": "Gemr...",
    "holePickerTitle": "Vælg hul",
    "subgamePickerTitle": "Vælg delspil"
  },
  "hole": {
    "title": "Hul",
    "holeLabel": "Hul",
    "loading": "Indlæser hul...",
    "scoreButtonLabel": "Score",
    "scorePopupTitle": "{name} - {holeLabel} {hole}",
    "scorePopupHandicapLabel": "Handicap-slag {value}",
    "scorePopupHandicapAndIndexLabel": "Handicap-slag {handicap} · Hcp-index {index}",
    "scorePopupMeta": "Hcp-index {hcpIndex} · Par {par}",
    "placeholder": "Pointregistrering kommer här.",
    "roundId": "Runde: {id}",
    "tourId": "Tour: {id}",
    "gameFallbackName": "Spil",
    "playerBreakdownTitle": "Point for {name}",
    "playerBreakdownEmpty": "Ingen point at vise.",
    "positionShort": "Plats {position}",
    "positionShared": "deled",
    "roundPointsMissing": "-",
    "leaderboardShortTitle": "Leaderboard",
    "roundColumn": "Runde",
    "tourColumn": "Tour",
    "leaderboardRoundTitle": "⛳️ Leaderboard - runde (Turnering)",
    "noGamesSelected": "Ingen spil valda. Leaderboarden er dold.",
    "unknownPlayer": "Okänd spillere",
    "gamesTitle": "🏆 Spil",
    "mysteryPrizeTitle": "Mysterypris",
    "missingRound": "Ingen runde vald.",
    "goPlayers": "Gå til spillere",
    "mysteryPrizeEntry": "{subgame} - {player}",
    "mysteryPrizeEntryWinner": "{subgame} - {player} (vinnare {winner})",
    "mysteryPrizeNone": "Inget mysterypris for det här hulet.",
    "noPlayers": "Ingen spillere at vise.",
    "puttOne": "1 putt",
    "puttTwo": "2 puttar",
    "puttThree": "3 puttar",
    "puttPlus": "+ puttar",
    "eightPlusLabelWithValue": "8+({value})",
    "mysteryPrizeUnknownSubgame": "Okänt delspil",
    "mysteryPrizeUnknownPlayer": "Okänd spillere",
    "mysteryPrizeWinnerTitle": "Vælg vinnare",
    "mysteryPrizeWinnerSaveFailed": "Kunne ikke gemme mystery prize-vinnare.",
    "mysteryPrizeNextHoleTitle": "Mysterypris næste hul",
    "mysteryPrizeNextHoleSubtitle": "På hul {hole} er mysterypriserna valda så här:",
    "mysteryPrizeSelectWinner": "Vælg vinnare",
    "mysteryPrizeBack": "Tilbage",
    "backButton": "<- Tilbage",
    "showDetails": "Visa detaljer",
    "hideDetails": "Dölj detaljer",
    "pickup": "Pickup",
    "roundStateTitle": "Round state",
    "roundStateEmpty": "Ingen round state mottagen.",
    "close": "Luk",
    "leaderboardChangeTitle": "Leaderboard ændret",
    "leaderboardChangeSubtitle": "Alle scorer er registreret for hul {hole}",
    "leaderboardChangeViewLeaderboard": "Vis leaderboard",
    "leaderboardChangeContinue": "Fortsæt",
    "netScoreLabel": "Netto",
    "netSummary": "Netto {net}{vsPar}",
    "netSummaryEmpty": "Netto –",
    "stablefordLabel": "Stableford",
    "menuTitle": "Vælg hul",
    "menuButton": "Hul {hole}",
    "menuPlayed": "Spilat",
    "menuNotPlayed": "Ej spilat",
    "menuMyScore": "Min score: {score}",
    "menuScoreMissing": "—",
    "menuCurrent": "Aktuellt hul",
    "prevHole": "Föregående hul",
    "prevHoleSwipeHint": "Stryg igen for at gå til forrige hul.",
    "nextHole": "Nästa hul",
    "nextHoleSwipeHint": "Stryg igen for at gå til næste hul.",
    "finishRound": "Avsluta runde",
    "finishRoundHint": "Tryk for at afslutte runden.",
    "finishSendFailed": "Det lykkedes ikke at afslutte runden.",
    "eventSendFailed": "Det lykkedes ikke at sende hændelsen.",
    "event": {
      "water": "Vatten",
      "penalty": "Straff",
      "bunker": "Bunker",
      "threePutt": "3 puttar"
    },
    "parBadge": "Par {par}",
    "hcpIndexBadge": "Index {hcpIndex}",
    "playersLoadFailed": "Kunne ikke hente spillere."
  },
  "games": {
    "definitions": {
      "stableford": {
        "name": "Stableford",
        "info": "Pointspil baserat på resultater mot par per hul.",
        "description": "Spillere får point per hul utifrån nettresultater mot par."
      },
      "stroke-play": {
        "name": "Slagspil",
        "info": "Laveste samlede antal slag vinder.",
        "description": "Spillere rangeres efter bruttoantal slag over runden, hvor lavere total giver bedre placering."
      },
      "skins": {
        "name": "Skins",
        "info": "Varje hul er värt en skin.",
        "description": "Bästa score på hulet vinner skin; delning rullar över til næste hul."
      },
      "best-ball": {
        "name": "Best Ball",
        "info": "Lagformat som räknar bästa score per hul.",
        "description": "Varje lag räknar sin bästa spilleres score på varje hul."
      },
      "bunker": {
        "name": "Bunker",
        "info": "Händelsespil for bunkerutfall.",
        "description": "Spårar bunkersketelser under runden."
      },
      "water": {
        "name": "Vatten",
        "info": "Händelsespil for vattenhinder.",
        "description": "Spårar vattenhindersketelser under runden."
      },
      "3-putts": {
        "name": "3 puttar",
        "info": "Händelsespil for treputtar.",
        "description": "Spårar hul där spillere behöver tre puttar."
      },
      "closest-to-flag": {
        "name": "Närmast flagg",
        "info": "Utmaningsspil for precision på utvalda hul.",
        "description": "Spilleren närmast flaggan vinner utmaningen på valt hul."
      },
      "longest-1-put": {
        "name": "Längsta 1 putt",
        "info": "Utmaningsspil for längsta enputt.",
        "description": "Längsta lyckade enputt vinner på valt hul."
      },
      "longest-drive": {
        "name": "Längsta drive",
        "info": "Utmaningsspil for utslagslängd.",
        "description": "Längsta giltiga drive vinner på valt hul."
      },
      "b1f4b6d5-3a7e-4d0a-8d3b-2e4f6a7b8c9d": {
        "name": "Mystery-pris",
        "info": "Hjemligt sidospil med valt delspil og hul.",
        "description": "Varje spillere får et dolt delspil for et valt hul, sedan utses en vinnare."
      }
    },
    "subgames": {
      "d4d2a4b1-5a9b-4f0d-9b94-1a8f8a5c2e11": {
        "name": "Närmast flagg",
        "description": "Närmast flaggan på det valda hulet."
      },
      "3e92a03c-5b70-4a3a-aad1-7db36de37d5e": {
        "name": "Längsta drive",
        "description": "Längsta drive på det valda hulet."
      },
      "7c1cfd58-9171-4b4a-9a71-6f1d8b9b5c30": {
        "name": "Längsta 1 putt",
        "description": "Längsta enputt på det valda hulet."
      }
    }
  }
}
